/**
 * jc-blog.js
 * Upload to: Assets/jc-blog.js
 * Used by: sections/blog-index.liquid
 *
 * Handles:
 *  - Topic pill active state based on URL
 *  - Newsletter form feedback (Shopify handles the POST, this handles UX)
 */

(function () {
  'use strict';

  // ── TOPIC PILLS: set active state from URL ──────────────────────────────
  var pills = document.querySelectorAll('.jc-topic-pill');
  var currentPath = window.location.pathname;
  var currentSearch = window.location.search;

  pills.forEach(function (pill) {
    var pillHref = pill.getAttribute('href') || '';

    // Remove active from all
    pill.classList.remove('active');

    // "All articles" pill — active when no tag in URL
    if (
      pillHref.indexOf('/tagged/') === -1 &&
      currentPath.indexOf('/tagged/') === -1
    ) {
      pill.classList.add('active');
    }

    // Tagged pill — active when URL contains the same tag slug
    if (
      pillHref.indexOf('/tagged/') !== -1 &&
      currentPath.indexOf('/tagged/') !== -1
    ) {
      var pillTag = pillHref.split('/tagged/')[1];
      var urlTag = currentPath.split('/tagged/')[1];
      if (pillTag && urlTag && pillTag === urlTag) {
        // Remove from "all" pill first
        pills[0] && pills[0].classList.remove('active');
        pill.classList.add('active');
      }
    }
  });

  // ── NEWSLETTER FORM: smooth scroll to success message ──────────────────
  var nlForm = document.getElementById('jc-blog-newsletter');
  if (nlForm) {
    var successMsg = nlForm.querySelector('.jc-nl-success');
    if (successMsg) {
      successMsg.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // ── IMAGE LAZY LOAD FALLBACK for older browsers ─────────────────────────
  if ('loading' in HTMLImageElement.prototype) {
    // Native lazy loading supported — nothing to do
  } else {
    // Intersection Observer fallback
    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
            }
            observer.unobserve(img);
          }
        });
      }, { rootMargin: '200px 0px' });

      lazyImages.forEach(function (img) { observer.observe(img); });
    }
  }

})();